const initialState = {
  publishTrack: [],
  permissionFlags: null,
  collectionSnapshots: [],
  folderStructure: [],
  allActivity: [],
  storedIpAddresses: [],
  editorValue: '',
  cssUuid: '',
  customCssCdnData: {},
  cssEditorValue: '',
  isOpenCssEditorModal: false,
  jsEditorValue: '',
  isOpenJsEditorModal: false,
  jsuuid: '',
  customJsCdnData: {},
  projectDetail: null,
  defaultPage: null,
  pages: [],
  userRoles: [],
  allPermissions: [],
  pageSnapshots: [],
  snippetSnapshots: [],
  layouts: [],
  versions: [],
  localization: '',
  customHtmlFiles: [],
  projectCollections: [],
  projectDevApis: [],
  emailTemplate: [],
  profilersList: {},
  allResources: null,
  pageDetails: null,
  showPageSnapshotName: false,
  addProjectConstantPending: false,
  addProjectConstantError: null,
  deleteProjectConstantPending: false,
  deleteProjectConstantError: null,
  updateProjectConstantPending: false,
  updateProjectConstantError: null,
  addProjectCustomCssPending: false,
  addProjectCustomCssError: null,
  loadDefaultPagePending: false,
  loadDefaultPageError: null,
  addProjectRobotsTxtPending: false,
  addProjectRobotsTxtError: null,
  loadAppSettingPagesPending: false,
  loadAppSettingPagesError: null,
  loadPageSnapshotsPending: false,
  loadPageSnapshotsError: null,
  loadSnippetSnapshotsPending: false,
  loadSnippetSnapshotsError: null,
  changeProjectLoadingIconPending: false,
  changeProjectLoadingIconError: null,
  saveLayoutPending: false,
  saveLayoutError: null,
  loadLayoutsPending: false,
  loadLayoutsError: null,
  deleteLayoutPending: false,
  deleteLayoutError: null,
  updateLayoutPending: false,
  updateLayoutError: null,
  addProjectCustomCssClassPending: false,
  addProjectCustomCssClassError: null,
  deleteProjectCustomCssClassPending: false,
  deleteProjectCustomCssClassError: null,
  addEnvironmentInProjectPending: false,
  addEnvironmentInProjectError: null,
  removeEnvironmentFromProjectPending: false,
  removeEnvironmentFromProjectError: null,
  addProjectCustomCssUrlPending: false,
  addProjectCustomCssUrlError: null,
  deleteProjectCustomCssUrlPending: false,
  deleteProjectCustomCssUrlError: null,
  addProjectCustomJsPending: false,
  addProjectCustomJsError: null,
  addProjectCustomJsCdnPending: false,
  addProjectCustomJsCdnError: null,
  deleteProjectCustomJsCdnPending: false,
  deleteProjectCustomJsCdnError: null,
  updateProjectCustomJsCdnPending: false,
  updateProjectCustomJsCdnError: null,
  updateProjectCustomCssCdnPending: false,
  updateProjectCustomCssCdnError: null,
  toggleProjectDefaultJsPending: false,
  toggleProjectDefaultJsError: null,
  saveProjectPwaConfigPending: false,
  saveProjectPwaConfigError: null,
  deleteProjectPwaConfigPending: false,
  deleteProjectPwaConfigError: null,
  togglePwaPending: false,
  togglePwaError: null,
  loadExportRequestListPending: false,
  loadExportRequestListError: null,
  deleteExportRequestPending: false,
  deleteExportRequestError: null,
  downloadCodePending: false,
  downloadCodeError: null,
  saveDbExportRequestPending: false,
  saveDbExportRequestError: null,
  loadDbExportRequestListPending: false,
  loadDbExportRequestListError: null,
  deleteDbExportRequestPending: false,
  deleteDbExportRequestError: null,
  downloadDbDumpPending: false,
  downloadDbDumpError: null,
  updateDevKeyPending: false,
  updateDevKeyError: null,
  updateEnvironmentProjectPending: false,
  updateEnvironmentProjectError: null,
  addEnvConstantPending: false,
  addEnvConstantError: null,
  updateEnvConstantPending: false,
  updateEnvConstantError: null,
  removeEnvConstantPending: false,
  removeEnvConstantError: null,
  toggleDevKeyPending: false,
  toggleDevKeyError: null,
  loadCustomCssCdnsPending: false,
  loadCustomCssCdnsError: null,
  loadCustomJsCdnsPending: false,
  loadCustomJsCdnsError: null,
  toggleEncryptionPending: false,
  toggleEncryptionError: null,
  updateEncryptionSettingPending: false,
  updateEncryptionSettingError: null,
  addNotificationSettingPending: false,
  addNotificationSettingError: null,
  deletePageSnapshotPending: false,
  deletePageSnapshotError: null,
  deleteSnippetSnapshotPending: false,
  deleteSnippetSnapshotError: null,
  loadLocalizationDataPending: false,
  loadLocalizationDataError: null,
  addLocalizationKeyValuePending: false,
  addLocalizationKeyValueError: null,
  deleteLocalizationKeyValuePending: false,
  deleteLocalizationKeyValueError: null,
  updateLocalizationKeyValuePending: false,
  updateLocalizationKeyValueError: null,
  saveLocalizationConfigPending: false,
  saveLocalizationConfigError: null,
  deleteLocalizationConfigPending: false,
  deleteLocalizationConfigError: null,
  changeDefaultLanguagePending: false,
  changeDefaultLanguageError: null,
  fetchFolderStructurePending: false,
  fetchFolderStructureError: null,
  fetchFileDetailsPending: false,
  fetchFileDetailsError: null,
  updateDateFormatPending: false,
  updateDateFormatError: null,
  fetchCssdataPending: false,
  fetchCssdataError: null,
  fetchJsEditorDataPending: false,
  fetchJsEditorDataError: null,
  saveCssFilePending: false,
  saveCssFileError: null,
  saveJsFilePending: false,
  saveJsFileError: null,
  toggleProjectCustomJsPending: false,
  toggleProjectCustomJsError: null,
  toggleProjectDefaultCssPending: false,
  toggleProjectDefaultCssError: null,
  toggleProjectJsCdnsFromBuilderPending: false,
  toggleProjectCssCdnsFromBuilderPending: false,
  toggleProjectCssCdnsFromBuilderError: null,
  toggleProfilerPending: false,
  toggleProfilerError: null,
  getAllTrackingActivityPending: false,
  getAllTrackingActivityError: null,
  loadProjectVersionPending: false,
  loadProjectVersionError: null,
  createProjectVersionPending: false,
  createProjectVersionError: null,
  loadProjectDetailAppSettingPending: false,
  loadProjectDetailAppSettingError: null,
  deleteProjectVersionPending: false,
  deleteProjectVersionError: null,
  getPublishtrackPending: false,
  getPublishtrackError: null,
  loadAllResourcesPending: false,
  loadAllResourcesError: null,
  deleteResourcesPending: false,
  deleteResourcesError: null,
  loadPageDetailsPending: false,
  loadPageDetailsError: null,
  updatePageScriptPending: false,
  updatePageScriptError: null,
  loadProjectCollectionsPending: false,
  loadProjectCollectionsError: null,
  enableDeveloperApisPending: false,
  enableDeveloperApisError: null,
  getAllDevApisPending: false,
  getAllDevApisError: null,
  loadEmailTemplatesPending: false,
  loadEmailTemplatesError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  updateIpAddressesPending: false,
  updateIpAddressesError: null,
  loadUserRolesPending: false,
  loadUserRolesError: null,
  enableRolesInDevApisPending: false,
  enableRolesInDevApisError: null,
  loadPermissionsPending: false,
  loadPermissionsError: null,
  enablePermissionsInDevApisPending: false,
  enablePermissionsInDevApisError: null,
  customDomainsUpdatePending: false,
  customDomainsUpdateError: null,
  fetchProjectPending: false,
  fetchProjectError: null,
  loadCollectionSnapshotsPending: false,
  loadCollectionSnapshotsError: null,
  deleteCollectionSnapshotPending: false,
  deleteCollectionSnapshotError: null,
  addProjectSitemapXmlPending: false,
  addProjectSitemapXmlError: null,
  overwriteDefaultUiPending: false,
  overwriteDefaultUiError: null,
  updateEncAwsSettingPending: false,
  updateEncAwsSettingError: null,
  resetEncryptionSettingPending: false,
  resetEncryptionSettingError: null,
  cypherTextPending: false,
  cypherTextError: null,
  getProfilerDataPending: false,
  getProfilerDataError: null,
  deleteProfilerPending: false,
  deleteProfilerError: null,
  updateAiModelConfigPending: false,
  updateAiModelConfigError: null,
  loaderScreenSettingsPending: false,
  loaderScreenSettingsError: null,
  refreshProjectPending: false,
  refreshProjectError: null,
  importProjectPending: false,
  importProjectError: null,
  fetchFigmatokenPending: false,
  fetchFigmatokenError: null,
  fetchFigmaDataPending: false,
  fetchFigmaDataError: null,
  fetchFigmaImagePending: false,
  fetchFigmaImageError: null,
  deleteFigmaToHtmlDataPending: false,
  deleteFigmaToHtmlDataError: null,
  deleteFigmaTokenDetailsPending: false,
  deleteFigmaTokenDetailsError: null,
  fetchFigmaToHtmlDataPending: false,
  fetchFigmaToHtmlDataError: null,
  generateFigmaToHtmlPending: false,
  generateFigmaToHtmlError: null,
  toggleDataMaskingPending: false,
  toggleDataMaskingError: null,
  runProjectPHIAuditPending: false,
  runProjectPHIAuditError: null,
  loadProjectPHIAuditPending: false,
  loadProjectPHIAuditError: null,
  projectPHIAudit: {},
  devApiKeys: [],
  devApiKeysTotalCount: 0,
  devApiKeysTotalPages: 1,
  devApiKeysCurrentPage: 1,
  devApiKeysLimit: 10,
  devApiKeysEnvCounts: {},
  fetchDevApiKeysPending: false,
  fetchDevApiKeysError: null,
  createDevApiKeyPending: false,
  createDevApiKeyError: null,
  updateDevApiKeyStatusPending: false,
  updateDevApiKeyStatusError: null,
  deleteDevApiKeyPending: false,
  deleteDevApiKeyError: null,
};

export default initialState;
